'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiPaginationItem, {
  type PaginationItemTypeMap as MuiPaginationItemTypeMap,
} from '@mui/material/PaginationItem';

type ExcludedMuiProps = '';

type CustomProps = {
  component?: ElementType;
};

type PaginationItemTypeMap<
  P = CustomProps,
  D extends ElementType = MuiPaginationItemTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiPaginationItemTypeMap['props'], ExcludedMuiProps> & P;
};

export type PaginationItemProps<
  D extends ElementType = MuiPaginationItemTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiPaginationItemTypeMap<P, D>, D>;

const PaginationItemComponent = (
  props: PaginationItemProps,
  ref: Ref<HTMLDivElement>
) => {
  return <MuiPaginationItem {...props} ref={ref} />;
};

PaginationItemComponent.displayName = 'PaginationItem';

export const PaginationItem = forwardRef(
  PaginationItemComponent
) as OverridableComponent<PaginationItemTypeMap>;
